import { render, staticRenderFns } from "./SuperAdminColleges.vue?vue&type=template&id=f9f02a22&"
import script from "./SuperAdminColleges.vue?vue&type=script&lang=js&"
export * from "./SuperAdminColleges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports